import { defineComponent as _defineComponent } from 'vue'
import { store } from '../store';
import { i18n } from '@/assets/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectModal',
  emits: ['onError'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

function connect(type: 'heartRate' | 'power' | 'debug') {
  try {
    store.connect(type);
  } catch (e) {
    emit('onError', JSON.stringify(e, null, 2));
  }
}

const __returned__ = { emit, connect, get store() { return store }, get i18n() { return i18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})